import React from 'react'

const FreshJourney = () => {
    return (
        <>
            <div className="our-journey" style={{ marginTop: "-70px" }}>
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">
                            {/* Section Title Start */}
                            <div className="section-title section-title-center">
                                <h3 className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>MAHUA Shakti Blend</h3>
                                <h2 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                    <div className="split-line" style={{ display: 'block', textAlign: 'center', position: 'relative' }}>
                                        MAHUA Shakti Blend – Crafted for Energy & Wellness
                                    </div>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Journey Item List Start */}
                            <div className="journey-item-list">
                                {/* Our Journey Item Start */}
                                <div className="journey-item">
                                    <div className="journey-title">
                                        <p>Satisfied client</p>
                                    </div>
                                    <div className="journey-content">
                                        <div className="icon-box">
                                            <img src="assets/images/icon-our-journey-1.svg" alt />
                                        </div>
                                        <div className="journey-counter">
                                            <h2><span className="counter">99</span>%</h2>
                                        </div>
                                    </div>
                                </div>
                                {/* Journey Item End */}
                                {/* Our Journey Item Start */}
                                <div className="journey-item">
                                    <div className="journey-title">
                                        <p>Our Teams</p>
                                    </div>
                                    <div className="journey-content">
                                        <div className="icon-box">
                                            <img src="assets/images/icon-our-journey-2.svg" alt />
                                        </div>
                                        <div className="journey-counter">
                                            <h2><span className="counter">06</span>+</h2>
                                        </div>
                                    </div>
                                </div>
                                {/* Journey Item End */}
                                {/* Our Journey Item Start */}
                                <div className="journey-item">
                                    <div className="journey-title">
                                        <p>Our experience</p>
                                    </div>
                                    <div className="journey-content">
                                        <div className="icon-box">
                                            <img src="assets/images/icon-our-journey-3.svg" alt />
                                        </div>
                                        <div className="journey-counter">
                                            <h2><span className="counter">10</span>+</h2>
                                        </div>
                                    </div>
                                </div>
                                {/* Journey Item End */}
                                {/* Our Journey Item Start */}
                                <div className="journey-item">
                                    <div className="journey-title">
                                        <p>Our Award recognitions</p>
                                    </div>
                                    <div className="journey-content">
                                        <div className="icon-box">
                                            <img src="assets/images/icon-our-journey-4.svg" alt />
                                        </div>
                                        <div className="journey-counter">
                                            <h2><span className="counter">06</span>+</h2>
                                        </div>
                                    </div>
                                </div>
                                {/* Journey Item End */}
                            </div>
                            {/* Journey Item List End */}
                        </div>
                        <div className="col-lg-12">
                            {/* Journey List Start */}
                            <div className="journey-list wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <ul>
                                    <li>In-House Lab Testing of product</li>
                                    <li>On-Site Quality Check of Produ</li>
                                    <li>Advanced Safety Testing for Ingr</li>
                                    <li>Certified Lab Approval Before of</li>
                                </ul>
                            </div>
                            {/* Journey List End */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FreshJourney